import { render, staticRenderFns } from "./PolicyResult.vue?vue&type=template&id=fab68ea6&scoped=true"
import script from "./PolicyResult.vue?vue&type=script&lang=js"
export * from "./PolicyResult.vue?vue&type=script&lang=js"
import style0 from "./PolicyResult.vue?vue&type=style&index=0&id=fab68ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab68ea6",
  null
  
)

export default component.exports